export function vec2Dist(x0: number, y0: number, x1: number, y1: number) {
  const dx = x0 - x1;
  const dy = y0 - y1;
  return Math.sqrt(dx * dx + dy * dy);
}

export function vec2Sub(x0: number, y0: number, x1: number, y1: number) {
  return [x1 - x0, y1 - y0];
}

export function vec2Tangent(x0: number, y0: number, x1: number, y1: number) {
  const dx = x1 - x0;
  const dy = y1 - y0;

  const len = Math.sqrt(dx * dx + dy * dy);
  return [dx / len, dy / len];
}

export function vec2Normal(x0: number, y0: number, x1: number, y1: number) {
  // rotates 90 degrees ccw
  const [x, y] = vec2Tangent(x0, y0, x1, y1);
  return [-y, x];
}

export function vec2Lerp(x0: number, y0: number, x1: number, y1: number, t: number) {
  const dx = x1 - x0;
  const dy = y1 - y0;
  return [x0 + dx * t, y0 + dy * t];
}

export function vec2IsBetween(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  testx: number,
  testy: number,
  tol: number = 1e-6,
) {
  const dx = x1 - x0;
  const dy = y1 - y0;

  const len = Math.sqrt(dx * dx + dy * dy);

  const dx0 = testx - x0;
  const dy0 = testy - y0;

  const crossproduct = dy0 * dx - dx0 * dy;

  // compare versus epsilon for floating point values
  if (Math.abs(crossproduct) > tol) {
    return false;
  }

  const dotproduct = dx0 * dx + dy0 * dy;
  if (dotproduct / len < -tol) {
    return false;
  }

  const squaredlengthba = dx * dx + dy * dy;
  if (dotproduct > squaredlengthba + tol) {
    return false;
  }

  return true;
}
